import React, {useRef} from 'react';
import {UserInfo} from "./controls-user/User-info";
import {ReactComponent as ProfileIcon} from '../../../../../../assets/header/profile.svg';


export const Controls = () => {

    const profileSelectRef = useRef(null);



    const openJivoChat = () => {
        if (window.jivo_api && typeof window.jivo_api.open === 'function') {
            window.jivo_api.open();
        } else {
            console.error('Jivo API недоступен');
        }
    };


    return (
        <div className="controls-col col" ref={profileSelectRef}>
            <div className="app-profile-box">
                <div onClick={openJivoChat} className="profile-prompt">
                    <ProfileIcon/>
                </div>
                <UserInfo/>
            </div>
        </div>
    );
};
